//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SeoText',
  data() {
    return {
      showBtn: false,
      showSeo: false,
      contentHeight: this.visibleHeight,
      scrollHeight: 0,
      aria: this._('Показать еще'),
    }
  },
  props: {
    visibleHeight: {
      default: 0,
    },
  },
  mounted() {
    this.innerHeight()
  },
  methods: {
    innerHeight() {
      const delay = 500
      setTimeout(() => {
        if (this.$refs.text.scrollHeight > this.visibleHeight) {
          this.scrollHeight = this.$refs.text.scrollHeight
          this.$refs.text.style.maxHeight = `${this.visibleHeight}px`
          this.showBtn = true
        }
      }, delay)
    },
    setHeight() {
      if (this.showSeo) {
        this.contentHeight = this.scrollHeight
        return
      }
      this.contentHeight = this.visibleHeight
    },
  },
}
